import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { MultiLanguageUrl } from '../../constants/multiLanguage.constant';

const FixNavigate = ({ to }: { to: string }) => {
  const { i18n } = useTranslation();
  return <Navigate to={`/${MultiLanguageUrl[i18n.language] || 'en-US'}${to}`} />;
};

export default FixNavigate;
